import { useQuery } from 'react-query'
import request from '../request'

export const useGetRoles = () => {
  return useQuery(['utils', 'roles'], () =>
    request({
      url: '/admin/roles',
      method: 'GET',
    }).then((res: any) => res.data),
  )
}
